

const Wallets = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="59"
      viewBox="0 0 66 59"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.308 26.0722C40.0702 26.0722 41.5321 27.568 41.5321 29.3961C41.5321 31.2242 40.1303 32.72 38.348 32.72H25.5316C23.7694 32.72 22.3275 31.2242 22.3275 29.3961C22.3275 27.568 23.7694 26.0722 25.5316 26.0722H38.1478H38.308ZM38.7623 23.1177H25.8361C22.2814 23.1177 19.373 25.943 19.373 29.3961C19.373 32.8492 22.2814 35.6745 25.8361 35.6745H38.7623C42.3169 35.6745 45.2253 32.8492 45.2253 29.3961C45.2253 25.943 42.3169 23.1177 38.7623 23.1177Z"
        fill="#4CAF50"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.1685 0.219971H0.168457V16.4289H3.41846V58.5722H61.9185V16.4289H65.1685V0.219971ZM58.5207 55.6177H6.81618V16.47H58.5207V55.6177ZM61.4753 12.7768H3.123V3.17452H61.4753V12.7768Z"
        fill="#4CAF50"
      />
    </svg>
  );
};

export default Wallets;
